import React, { useState, useRef, useCallback } from "react";
import { createPortal } from "react-dom";

/**
 * Figma field info tooltip — node 243-3234 / 243-3251
 * https://www.figma.com/design/bf8dF1bCgrmn6vscGI4rmb/dev?node-id=243-3234
 */
export default function FieldTooltip({ content, placement = "top" }) {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const updatePosition = useCallback(() => {
    const el = triggerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const gap = 8;

    if (placement === "bottom") {
      setCoords({
        top: rect.bottom + gap,
        left: rect.left + rect.width / 2,
      });
      return;
    }

    setCoords({
      top: rect.top - gap,
      left: rect.left + rect.width / 2,
    });
  }, [placement]);

  const show = () => {
    updatePosition();
    setVisible(true);
  };

  const hide = () => setVisible(false);

  if (!content) return null;

  const bubble =
    visible &&
    createPortal(
      <span
        className={`oh-field-tooltip-bubble oh-field-tooltip-bubble--${placement}`}
        style={{ top: coords.top, left: coords.left }}
        role="tooltip"
      >
        {content}
      </span>,
      document.body
    );

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="oh-field-tooltip-trigger"
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        aria-label={typeof content === "string" ? content : "More information"}
      >
        <img
          src="/images/information-circle.svg"
          alt=""
          width={14}
          height={14}
          aria-hidden="true"
        />
      </button>
      {bubble}
    </>
  );
}
